import React, { useState, useRef } from 'react';
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, Box,
  TablePagination, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RiCheckboxCircleLine } from "react-icons/ri";
import { RiFileExcel2Fill } from "react-icons/ri";
import { IoMdEye } from "react-icons/io";
import moment from 'moment';
import { Link } from 'react-router-dom';
import { CSVLink } from "react-csv";



const useStyles = makeStyles(() => ({
  root: {
    // width: '90vw',
    // height: '80vh',
    // margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  title: {
    fontWeight: 700,
    color: '#1e293b',
    marginBottom: '20px',
    textAlign: 'center',
  },
  headerCell: {
    backgroundColor: '#F47E46',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '16px',
    padding: '16px',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableRowOdd: {
    backgroundColor: '#f0f4f8',
  },
  cell: {
    fontSize: '14px',
    fontWeight: 'bold',
    padding: '16px',
    textAlign: 'center',
    borderRight: '1px solid #e0e0e0',
  },
  notesCell: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#555',
    padding: '16px',
    textAlign: 'center',
  },
}));

const DrawingQCTable = (props) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [csvData, setCsvData] = useState([]);
  const csvRef = useRef();  
  // Extract data from props safely
  const tableData = (props?.getCountData?.totalDrawingsData || [])
  .filter(item => item.drawingQcAdmApproved === true)
  .sort((a, b) => new Date(b.drawingQCRequestedApprovalDate) - new Date(a.drawingQCRequestedApprovalDate));

  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Get current page data
  const paginatedData = tableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // This is for Time Diff.
  const getTimeDifference = (start, end) => {
    if (!start || !end) return '-';
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate - startDate;

    if (isNaN(diffMs) || diffMs < 0) return '-';

    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const minutes = diffMins % 60;

    return `${hours} hr ${minutes} min`;
  };

  // Calculate time difference in days
  const getTimeDifferenceInDays = (start, end) => {
    if (!start || !end) return 'N/A';
    try {
      const startDate = new Date(start);
      const endDate = new Date(end);
      
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 'N/A';
      
      const diffMs = endDate - startDate;
      if (isNaN(diffMs) || diffMs < 0) return 'N/A';

      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      return diffDays === 1 ? `${diffDays} day` : `${diffDays} days`;
    } catch (error) {
      return 'N/A';
    }
  };

  const handleOpenRemarks = (logs) => {
    setSelectedRemarks(logs);
    setOpen(true);
  };
  
  
  const handleClose = () => {
    setOpen(false);
    setSelectedRemarks([]);
  };
  
  const handleChangeRowPerPage = (event) => {
      setRowsPerPage(Number(event.target.value));
      setPage(0);
  };

  const csvHeaders = [
    { label: "S. No", key: "serialNo" },
    { label: "Project No", key: "projectCode" },
    { label: "Quotation Value", key: "quotationValue" },
    { label: "Designer", key: "designer" },
    { label: "ODM", key: "odm" },
    { label: "Assigned QC Person", key: "assignedQCPerson" },
    { label: "QC Assignment Pending", key: "qcAssignmentPending" },
    { label: "Time Taken in Assignment", key: "timeTakenInAssignment" },
    { label: "QC 1 In Progress", key: "qc1InProgress" },
    { label: "Time Taken in QC1 completion", key: "timeTakenInQC1Completion" },
    { label: "QC 1 Completed", key: "qc1Completed" },
    { label: "Time in Stage", key: "timeInStage1" },
    { label: "QC 2 In Progress", key: "qc2InProgress" },
    { label: "Time Taken in QC2 correction", key: "timeTakenInQC2Correction" },
    { label: "QC 2 Correction Needed", key: "qc2CorrectionNeeded" },
    { label: "Time Taken in QC2 completion", key: "timeTakenInQC2Completion" },
    { label: "QC 2 Completed", key: "qc2Completed" },
    { label: "Time in Stage", key: "timeInStage2" },
    { label: "Final Signoff In Progress", key: "finalSignoffInProgress" },
    { label: "Final Signoff Completed", key: "finalSignoffCompleted" },
    { label: "Time in Stage", key: "timeInStage3" },
    { label: "Remarks", key: "remarks" },
  ];

  const handleDownload = () => {
    const csvFormattedData = tableData.map((item, index) => {
      // Helper function to get QC2 logs data
      const logs = item.drawingQCTwoApproveLogs || [];
      const firstLog = logs[0];
      const firstCorrectionLog = logs.find(log => log.correctionNeeded === true);
      const lastCompletedLog = logs.filter(log => log.qcTwoCompleted === true).pop();

      return {
        serialNo: index + 1,
        projectCode: item.erpProjectNo || "NA",
        quotationValue: item.drawingQtValue || "NA",
        designer: item.raisedQCDesignerName || "NA",
        odm: item.checkListDesignerSignatureName || "NA",
        assignedQCPerson: item.assignedQCPersonName || "NA",
        qcAssignmentPending: item.drawingQcAdmApproved ? "Yes" : "NA",
        timeTakenInAssignment: getTimeDifferenceInDays(item.drawingQcPendingApprovedAt, item.drawingQcAdmApprovedAt),
        qc1InProgress: item.assignedQCPersonStatus ? "Yes" : "NA",
        timeTakenInQC1Completion: getTimeDifferenceInDays(item.drawingQcPendingApprovedAt, item.drawingQcOneApprovedAt),
        qc1Completed: (item.drawingQcAdmApproved && item.drawingQcOneApproved) ? "Yes" : "NA",
        timeInStage1: (item.drawingQCRequestedApprovalDate && item.drawingQcAdmApproved && item.drawingQcOneApproved)
          ? getTimeDifferenceInDays(item.drawingQcAdmApprovedAt, item.drawingQcOneApprovedAt)
          : "NA",
        qc2InProgress: (item.drawingQcTwoRasiedDate && item.drawingQcOneApproved) ? "Yes" : "NA",
        timeTakenInQC2Correction: (logs.length > 0 && firstLog?.changeStatusAt && firstCorrectionLog?.changeStatusAt)
          ? getTimeDifferenceInDays(firstLog.changeStatusAt, firstCorrectionLog.changeStatusAt)
          : "NA",
        qc2CorrectionNeeded: (item.drawingQcTwoRasiedDate && item.drawingQcOneApproved && item.qc2CorrectionNeeded) ? "Yes" : "NA",
        timeTakenInQC2Completion: (logs.length > 0 && firstCorrectionLog?.changeStatusAt && lastCompletedLog?.changeStatusAt)
          ? getTimeDifferenceInDays(firstCorrectionLog.changeStatusAt, lastCompletedLog.changeStatusAt)
          : "NA",
        qc2Completed: (item.drawingQcTwoRasiedDate && item.drawingQcOneApproved && item.qc2CorrectionNeeded && item.drawingQcTwoApproved) ? "Yes" : "NA",
        timeInStage2: (item.drawingQCRequestedApprovalDate && item.drawingQcAdmApprovedAt && item.drawingQcOneApprovedAt && item.drawingQcTwoApproved)
          ? getTimeDifferenceInDays(item.drawingQcOneApprovedAt, item.drawingQcTwoApprovedAt)
          : "NA",
        finalSignoffInProgress: (item.drawingQcTwoRasiedDate && item.drawingQcOneApproved && item.drawingQcTwoApproved && item.qcFinalSignoffInProgress) ? "Yes" : "NA",
        finalSignoffCompleted: (item.drawingQcTwoRasiedDate && item.drawingQcOneApproved && item.drawingQcTwoApproved && item.qcFinalSignoffInProgress && item.qcFinalSignoffCompleted) ? "Yes" : "NA",
        timeInStage3: (item.drawingQCRequestedApprovalDate && item.drawingQcAdmApprovedAt && item.drawingQcOneApprovedAt && item.drawingQcTwoApproved && item.qcFinalSignoffInProgressAt && item.qcFinalSignoffCompletedAt)
          ? getTimeDifferenceInDays(item.qcFinalSignoffInProgressAt, item.qcFinalSignoffCompletedAt)
          : "NA",
        remarks: item.remarks || "NA",
      };
    });
    setCsvData(csvFormattedData);
    setTimeout(() => csvRef.current.link.click(), 0);
  };


  return (
    <>
      <Box className={classes.root}>
        <Typography variant="h4" className={classes.title}>
          Drawing QC Status Table
        </Typography>

        <div style={{ textAlign: 'right', margin: '10px 0' }}>
          <Button
            variant="contained"
            style={{ backgroundColor: "#355025", color: "#FFF2EB" }}
            onClick={handleDownload}
          >
            <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
            Download CSV
          </Button>

          <CSVLink
            data={csvData}
            headers={csvHeaders}
            filename={`drawing-qc-status-table-${new Date().toISOString().split('T')[0]}.csv`}
            ref={csvRef}
            style={{ display: "none" }}
          />
        </div>

        <TableContainer component={Paper} style={{ flexGrow: 1 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell colSpan={22}>
                  <TablePagination
                    rowsPerPageOptions={[10, 50, 100, { label: 'All', value: tableData.length}]}
                    component="div"
                    count={tableData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onRowsPerPageChange={handleChangeRowPerPage}
                    onPageChange={handleChangePage}
                    style={{ flexShrink: 0 }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headerCell}>S. No</TableCell>
                {[
                  "Project No", "Quotation Value", "Designer", "ODM", "Assigned QC Person", 
                  "QC Assignment Pending","Time Taken in Assignment",
                  "QC 1 In Progress","Time Taken in QC1 completion", "QC 1 Completed", "Time in Stage",
                  "QC 2 In Progress", "Time Taken in QC2 correction", "QC 2 Correction Needed ", "Time Taken in QC2 completion", "QC 2 Completed", "Time in Stage",
                  "Final Signoff In Progress", "Final Signoff Completed",
                  "Time in Stage", "Remarks"
                ].map((header, index) => (
                  <TableCell key={index} className={classes.headerCell}>{header}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedData.map((row, index) => (
                <TableRow
                  key={index}
                  className={index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
                >
                  <TableCell className={classes.cell}>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell className={classes.cell}>
                    {row.erpProjectNo ? (
                      <span
                        onClick={() => window.open(`/project-logs/${row._id}`, '_blank', 'noopener,noreferrer')}
                        style={{ 
                          color: "rgba(0, 0, 0, 0.87)", 
                          textDecoration: 'underline', 
                          cursor: 'pointer' 
                        }}
                      >
                        {row.erpProjectNo}
                      </span>
                    ) : 'NA'}
                  </TableCell>
                  <TableCell className={classes.cell}>{row.drawingQtValue || 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>{row.raisedQCDesignerName || 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>{row.checkListDesignerSignatureName || 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>{row.assignedQCPersonName || 'N/A'}</TableCell>
                  
                  <TableCell className={classes.cell}>{(row.drawingQcAdmApproved ) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                    : 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>
                    {getTimeDifferenceInDays(row.drawingQcPendingApprovedAt, row.drawingQcAdmApprovedAt)}
                  </TableCell>

                  <TableCell className={classes.cell}>{(row.assignedQCPersonStatus ) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                    : 'N/A'}</TableCell>
                  <TableCell className={classes.cell}>
                    {getTimeDifferenceInDays(row.drawingQcPendingApprovedAt, row.drawingQcOneApprovedAt)}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQcAdmApproved && row.drawingQcOneApproved ) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                      : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQCRequestedApprovalDate && row.drawingQcAdmApproved && row.drawingQcOneApproved)
                      ? getTimeDifferenceInDays(row.drawingQcAdmApprovedAt, row.drawingQcOneApprovedAt)
                      : 'N/A'}
                  </TableCell>

                  <TableCell className={classes.cell}>
                    {(row.drawingQcTwoRasiedDate && row.drawingQcOneApproved) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                      : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(() => {
                      const logs = row.drawingQCTwoApproveLogs || [];
                      if (logs.length === 0) return 'N/A';
                      
                      const firstLog = logs[0];
                      const firstCorrectionLog = logs.find(log => log.correctionNeeded === true);
                      
                      if (!firstLog?.changeStatusAt || !firstCorrectionLog?.changeStatusAt) {
                        return 'N/A';
                      }
                      
                      return getTimeDifferenceInDays(firstLog.changeStatusAt, firstCorrectionLog.changeStatusAt);
                    })()}
                  </TableCell>
                  <TableCell className={classes.cell}>
                  {(row.drawingQcTwoRasiedDate && row.drawingQcOneApproved && row.qc2CorrectionNeeded) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                  : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(() => {
                      const logs = row.drawingQCTwoApproveLogs || [];
                      if (logs.length === 0) return 'N/A';
                      
                      // Find first QC2 Correction Needed (first element where correctionNeeded === true)
                      const firstCorrectionLog = logs.find(log => log.correctionNeeded === true);
                      
                      // Find last QC2 Completed (last element where qcTwoCompleted === true)
                      const lastCompletedLog = logs.filter(log => log.qcTwoCompleted === true).pop();
                      
                      if (!firstCorrectionLog?.changeStatusAt || !lastCompletedLog?.changeStatusAt) {
                        return 'N/A';
                      }
                      
                      return getTimeDifferenceInDays(firstCorrectionLog.changeStatusAt, lastCompletedLog.changeStatusAt);
                    })()}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQcTwoRasiedDate && row.drawingQcOneApproved &&  row.qc2CorrectionNeeded && row.drawingQcTwoApproved) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                      : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQCRequestedApprovalDate && row.drawingQcAdmApprovedAt && row.drawingQcOneApprovedAt && row.drawingQcTwoApproved)
                      ? getTimeDifferenceInDays(row.drawingQcOneApprovedAt, row.drawingQcTwoApprovedAt)
                      : 'N/A'}
                  </TableCell>

                  <TableCell className={classes.cell}>
                    {(row.drawingQcTwoRasiedDate && row.drawingQcOneApproved && row.drawingQcTwoApproved && row.qcFinalSignoffInProgress) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                    : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQcTwoRasiedDate && row.drawingQcOneApproved && row.drawingQcTwoApproved && row.qcFinalSignoffInProgress && row.qcFinalSignoffCompleted) ? <RiCheckboxCircleLine style={{ fontSize: "30px", color: "green" }} />
                    : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {(row.drawingQCRequestedApprovalDate && row.drawingQcAdmApprovedAt && row.drawingQcOneApprovedAt && row.drawingQcTwoApproved && row.qcFinalSignoffInProgressAt && row.qcFinalSignoffCompletedAt)
                      ? getTimeDifferenceInDays(row.qcFinalSignoffInProgressAt, row.qcFinalSignoffCompletedAt)
                      : 'N/A'}
                  </TableCell>
                  <TableCell className={classes.notesCell}>
                  <IoMdEye
                    style={{ fontSize: "30px", color: "#FDB913", cursor: "pointer" }}
                    onClick={() => handleOpenRemarks(row)}
                  />
                </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Remarks</DialogTitle>
        <DialogContent dividers>
          {selectedRemarks ? (
            <Table>
            <TableHead>
            <TableRow>
              <TableCell className={classes.headerCell}>User</TableCell>
              <TableCell className={classes.headerCell}>Drawing QC Stages</TableCell>
              <TableCell className={classes.headerCell}>Approved/Uploaded Time</TableCell>
              <TableCell className={classes.headerCell}>Remarks by Designer and QC </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {/* ADM Approval */}
            {selectedRemarks?.drawingQcAdmApprovedAt && (
              <TableRow>
                <TableCell className={classes.valueCell}>{selectedRemarks?.checkListDesignerSignatureName}</TableCell>
                <TableCell className={classes.valueCell}>QC1 In progress</TableCell>
                <TableCell className={classes.valueCell}>
                  {moment(selectedRemarks.drawingQcAdmApprovedAt).format('DD-MM-YYYY hh:mm A')}
                </TableCell>
                <TableCell className={classes.cell}>
                  {selectedRemarks?.drawingQCFirstRemarks}
                </TableCell>
              </TableRow>
            )}

            {/* QC1 Approval */}
            {selectedRemarks?.drawingQcOneApprovedAt && (
              <TableRow>
                <TableCell className={classes.valueCell}>{selectedRemarks?.qc1UserName}</TableCell>
                <TableCell className={classes.valueCell}>QC1 Completed</TableCell>
                <TableCell className={classes.valueCell}>
                  {moment(selectedRemarks.drawingQcOneApprovedAt).format('DD-MM-YYYY hh:mm A')}
                </TableCell>
                <TableCell className={classes.cell}>
                  {selectedRemarks?.qc1Remarks}
                </TableCell>
              </TableRow>
            )}

            {/* QC2 Approval */}
            {Array.isArray(selectedRemarks?.drawingQCTwoApproveLogs) &&
              selectedRemarks.drawingQCTwoApproveLogs.length > 0 &&
              selectedRemarks.drawingQCTwoApproveLogs.map((log, index) => (
                <TableRow key={log._id || index}>
                  <TableCell className={classes.valueCell}>{log.qcUserName}</TableCell>
                  <TableCell className={classes.valueCell}>{log.status}</TableCell>
                  <TableCell className={classes.valueCell}>
                    {moment(log.drawingQcOneApprovedAt).format('DD-MM-YYYY hh:mm A')}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {log.qc2Remarks}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
            </Table>
          ) : (
            <Typography>No remarks available.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default connect(null, { setLoading, setSnackInfo })(DrawingQCTable);